import React, { CSSProperties } from 'react';
import styled from '../../styles/styled-components';
import Sidebar from 'react-sidebar';
import { SidebarContent } from './sidebar';
import { PageHeader } from '../pageHeader';
import { Paper } from '../paper';

const mql = window.matchMedia(`(min-width: 800px)`);

export const ScrollableContainerContext = React.createContext<
  React.RefObject<HTMLDivElement>
>(undefined);

// Dock the sidebar if device width is greater than 800px
// or if touch events aren't available.
function shouldDockSidebar() {
  return (
    window.matchMedia(`(min-width: 800px)`).matches ||
    !('ontouchstart' in window)
  );
}

type Props = {
  onLogout: () => void;
  customerName: string;
  deviceName: string;
  isSyncro: boolean;
  assetId: string | undefined;
} & Stylable;

type State = {
  sidebarOpened: boolean;
  sidebarDocked: boolean;
};

export class AppContainer extends React.Component<Props, State> {
  scrollableContentContainer: React.RefObject<HTMLDivElement>;

  constructor(props: Readonly<Props>) {
    super(props);

    this.state = {
      sidebarOpened: true,
      sidebarDocked: shouldDockSidebar(),
    };

    this.scrollableContentContainer = React.createRef();
  }

  handleSidebarSetOpen = (sidebarOpened: boolean) => {
    this.setState({
      sidebarOpened: sidebarOpened,
    });
  };

  handleCloseClicked = (ev: React.MouseEvent) => {
    this.setState({
      sidebarOpened: false,
      sidebarDocked: false,
    });
  };

  handleMenuClicked = (ev: React.MouseEvent) => {
    this.setState({
      sidebarOpened: true,
      sidebarDocked: shouldDockSidebar(),
    });
  };

  render() {
    const {
      onLogout,
      isSyncro,
      customerName,
      deviceName,
      assetId,
      children,
      ...rest
    } = this.props;

    const { sidebarOpened, sidebarDocked } = this.state;

    return (
      <Sidebar
        sidebar={
          <SidebarContent
            isSyncro={isSyncro}
            assetId={assetId}
            onCloseClick={this.handleCloseClicked}
          />
        }
        open={sidebarOpened}
        docked={sidebarDocked}
        onSetOpen={this.handleSidebarSetOpen}
        styles={{ sidebar: { width: '250px', zIndex: '3' } }}
      >
        <Page {...rest}>
          <StyledPageHeader
            onLogout={onLogout}
            customerName={customerName}
            deviceName={deviceName}
            onMenuClicked={this.handleMenuClicked}
            isSidebarOpen={this.state.sidebarOpened}
          />
          <div
            ref={this.scrollableContentContainer}
            style={ScrollableContainerCss}
          >
            <ScrollableContainerContext.Provider
              value={this.scrollableContentContainer}
            >
              {children}
            </ScrollableContainerContext.Provider>
          </div>
        </Page>
      </Sidebar>
    );
  }
}

const Page = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const ScrollableContainerCss = {
  height: 'calc(100vh - 50px)',
  maxHeight: 'calc(100vh - 50px)',
  overflowY: 'auto',
  padding: '0 20px',
} as CSSProperties;

const StyledPageHeader = styled(PageHeader)`
  height: 50px;
  z-index: 1;
`;
